<template>
  <main-content-layout :title="$gettext('SUPPORT_CALL')">
    <template v-slot:buttons>
        <q-btn icon="filter_list" @click="openFilterModal" flat :label="$gettext('FILTER')"/>
        <q-btn icon="note_add" @click="openAddModal" flat :label="$gettext('INCLUDE')"/>
    </template>

    <div class="tw-px-4">
      <q-tabs class="tw-mb-4" v-model="tab">
        <q-tab :name="50100003" :label="$gettext('ADMINISTRATIVE')" />
        <q-tab :name="50100001" :label="$gettext('FINANCIAL')" />
        <q-tab :name="50100002" :label="$gettext('OPERATIONAL')" />
      </q-tabs>
      <div class="tw-w-full">
        <div class="tw-flex tw-gap-4">
          <invoice-situation
            v-for="situationName in displayedSituations"
            :key="situationName"
            :text="situationMap[situationName].text"
            :color="situationMap[situationName].color"
            class="cursor-pointer"
            @click.native="statusButtonSearch(situationName)"
          />
        </div>
      </div>
    </div>
    <div class="tw-p-4">
      <jt-data-table
        :api-mode="false"
        :data="serviceOrderFormData"
        :fields="serviceOrderForm.columns"
        :is-paginated="false"
        hide-bottom
        noneselect
        @action-button="actionButton"
      >
        <template #header="{props}">
          <q-tr :props="props" class="table-header">
            <q-td style="width: 5px; text-align: center !important"> </q-td>
            <q-td
              v-for="col in props.cols"
              style="text-align: center !important"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-td>
            <q-td style="width: 5px; text-align: center !important"> </q-td>
          </q-tr>
        </template>
        <template #body="{ props }">
          <q-tr>
            <q-td style="text-align: center !important" auto-width> </q-td>
            <q-td
              v-for="col in props.cols"
              style="text-align: center !important"
              :key="col.name"
              :props="props"
            >

              <span v-if="col.field == 'callStatusType'">
                <span
                  class="index"
                  :style="
                    'background-color:' +
                    fieldColors[
                      fieldColorsKeys.find(
                        (key) => $gettext(key) === props.row.callStatusType
                      )
                    ]
                  "
                >
                  {{
                    $gettext(
                      fieldColorsKeys.find(
                        (key) => $gettext(key) === props.row.callStatusType
                      )
                    )
                  }}
                </span>
              </span>
              <span v-else>
                {{ col.value }}
              </span>
            </q-td>
            <q-td style="width: 1px; text-align: center !important" nowrap>
              <span class="buttons-row">
                <span :key="1" class="btAlterar">
                  <q-btn
                    flat
                    small
                    class="btAlterar-btn protocol-close"
                    color="primary"
                    @click="actionButtonChange(props.row)"
                  >
                    <q-icon name="border_color" size="22px" />
                    <q-tooltip>
                      {{ $gettext("CHANGE") }}
                    </q-tooltip>
                  </q-btn>
                </span>
                <span :key="0" class="btDetalhar">
                  <q-btn
                    flat
                    small
                    class="btAlterar-btn protocol-close"
                    color="primary"
                    @click="actionButtonDetail(props.row)"
                  >
                    <q-icon name="visibility" size="22px" />
                    <q-tooltip>
                      {{ $gettext("DETAIL") }}
                    </q-tooltip>
                  </q-btn>
                </span>
              </span>
            </q-td>
          </q-tr>
        </template>
      </jt-data-table>
    </div>
    <q-dialog v-model="renderModal" full-height>
      <q-layout
        view="Lhh lpR fff"
        container
        full-height
        class="bg-white modal-large jtSearchOwnershipChangeContainer"
      >
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title
              ><translate v-if="!editMode && !detailMode && !searchMode"
                >INCLUDE</translate
              >
              <translate v-else-if="editMode">EDIT</translate>
              <translate v-else-if="detailMode">DETAIL</translate>
              <translate v-else-if="searchMode">SEARCH</translate>
            </q-toolbar-title>
            <q-btn @click="closeModal" flat round dense icon="close" />
          </q-toolbar>
        </q-header>

        <q-footer class="bg-white">
          <div class="row full-width q-col-gutter-lg justify-center q-py-lg">
            <div key="cancel" class="col-lg col-lg-2 col-md-3">
              <q-btn
                v-if="!detailMode"
                class="full-width cancel-btn"
                @click="clearServiceOrder"
              >
                <translate>CANCEL</translate>
              </q-btn>
            </div>
            <div
              v-if="!editMode && !searchMode && !detailMode"
              key="save"
              class="col-lg-2 col-md-3"
            >
              <q-btn
                class="full-width"
                color="positive"
                @click="saveServiceOrder"
              >
                <translate>SAVE</translate>
              </q-btn>
            </div>
            <div v-else-if="editMode" key="edit" class="col-lg-2 col-md-3">
              <q-btn
                class="full-width"
                color="positive"
                @click="editServiceOrder"
              >
                <translate>EDIT</translate>
              </q-btn>
            </div>
            <div v-else-if="searchMode" key="edit" class="col-lg-2 col-md-3">
              <q-btn
                class="full-width"
                color="positive"
                @click="searchServiceOrder"
              >
                <translate>SEARCH</translate>
              </q-btn>
            </div>
          </div>
        </q-footer>
        <q-page-container class="full-height">
          <jt-dynamic-form
            v-if="!detailMode"
            ref="dynamicForm"
            :inputs="serviceOrderModalForm.inputs"
            :relacionamentos="serviceOrderModalForm.relacionamentos"
            :model="serviceOrderModalForm.dadosForm"
            :interface="serviceOrderModalForm.nmInterface"
            form-class="form"
            class="q-pr-lg q-pl-lg q-py-lg serviceOrderModalForm"
            @search-found="selections"
            @composition-button-click="compositionButtonClick"
          />
          <page-detail
            v-else
            :forms="serviceOrderModalForm"
            :name="name"
            :params="params"
            :parent="parent"
            @action-button="actionButtonHandler"
          >
          </page-detail>
        </q-page-container>
      </q-layout>
    </q-dialog>
    <q-dialog ref="docModal" maximized v-model="renderModalFile">
      <q-layout view="Lhh lpR fff" container class="bg-white">
        <q-header>
          <q-toolbar>
            <q-toolbar-title>{{
              $gettext("SUPPORT_CALL_FILE")
            }}</q-toolbar-title>
            <q-btn flat @click="closeModalFile">
              <q-icon name="close" />
            </q-btn>
          </q-toolbar>
        </q-header>
        <q-page-container>
          <q-page padding>
            <div v-if="extension === extensions.pdf">
              <pdf
                v-for="page in numPages"
                ref="pdfViewer"
                :key="page"
                :page="page"
                :src="source"
                :v-if="source"
                class="full-height full-width"
                @num-pages="pageCount = $event"
                @page-loaded="currentPage = $event"
              />
            </div>
            <img
              v-else-if="
                extension === extensions.jpg ||
                extension === extensions.png ||
                extension === extensions.jpeg
              "
              :src="source"
            />
          </q-page>
        </q-page-container>
      </q-layout>
    </q-dialog>
  </main-content-layout>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import ServiceRequestServiceOrderController from './ServiceRequestServiceOrderController'
import { GlobalController } from 'src/shared/global/GlobalController'
import { JtCrud, JtDataTable } from 'jtech-webcomps'
import { messageBox } from 'jtech'
import pdf from 'vue-pdf'
import MainContentLayout from '../Layout/MainContentLayout.vue'
import InvoiceSituation from '../financial/invoice/component/InvoiceSituation.vue'
import { situationMap } from '../financial/invoice/component/situation.config'
const { pageDetail } = JtCrud

@Component({
  name: 'ServiceRequestServiceOrder',
  components: { pageDetail, pdf, MainContentLayout, InvoiceSituation, JtDataTable },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class ServiceRequestServiceOrder extends Vue {
  renderModal = false;
  renderModalFile = false;
  currentPage = 0;
  extensions = { pdf: 'pdf', jpg: 'jpg', png: 'png', jpeg: 'jpeg' };
  fieldColors = { ALL_ORDERS: '#d8dada', SOLVED: '#becd88', OPEN_SUPPORT_CALL: '#b6ccd2', FINISHED: '#fff0a5', PROCESSING: '#cdb5f6', CANCELLED: '#e78b8b' }
  fieldColorsKeys = Object.keys(this.fieldColors)
  pageCount = 0;
  numPages = 0;
  source = '';
  extension = '';
  serviceOrderModalForm = {};
  serviceOrderForm = {};
  tab = 50100003;
  serviceOrderFormData = {};
  key = 0;
  controller = ServiceRequestServiceOrderController.getInstance();
  globalController = GlobalController.getInstance();
  editMode = false;
  detailMode = false;
  searchMode = false;

  displayedSituations = [
    'ALL_ORDERS',
    'SOLVED',
    'OPEN_SUPPORT_CALL',
    'FINISHED',
    'PROCESSING',
    'CANCELED'
  ];

  statusIdMap = {
    ALL_ORDERS: null,
    OPEN_SUPPORT_CALL: 50060001,
    PROCESSING: 50060002,
    CANCELED: 50060003,
    SOLVED: 50060004,
    FINISHED: 50060005
  };

  get situationMap () {
    return situationMap
  }

  async openAddModal () {
    const forms = await this.controller.loadFormGravar()
    this.serviceOrderModalForm = forms[0]
    await this.loadFields()
    this.renderModal = true
  }

  async openFilterModal () {
    this.searchMode = true
    const forms = await this.controller.loadFormPesquisar()
    this.serviceOrderModalForm = forms[0]
    const params = this.$route.params
    const consumerUnit = params.consumerUnit
    const serviceRequest = params.protocol
    this.serviceOrderModalForm.dadosForm.consumerUnit = consumerUnit
    this.serviceOrderModalForm.dadosForm.serviceRequest = serviceRequest
    this.renderModal = true
  }

  async compositionButtonClick ({ button, params }) {
    if (button.name === 'icDetalharArquivo') {
      params.fileExtension = params.name.split('.')[1]
      await this.showDocument(params, 'CONSUMER_UNIT_FILE')
      this.renderModalFile = true
    }
  }

  async statusButtonSearch (statusName) {
    const statusId = this.statusIdMap[statusName]

    const filtro = {
      consumerUnit: this.$route.params.consumerUnit,
      serviceRequest: this.$route.params.protocol,
      supportCallClassificationType: this.tab
    }

    if (statusId) {
      filtro.callStatusType = statusId
    }

    const { registros } = await this.controller.pesquisarServiceOrder(filtro)
    this.serviceOrderFormData = registros
  }

  async actionButtonHandler (button, params) {
    params.fileExtension = params.name.split('.')[1]
    await this.showDocument(params, 'CONSUMER_UNIT_FILE')
    this.renderModalFile = true
  }

  async showDocument (params, nmIdentificacaoParserFile) {
    this.extension = params.fileExtension
    const file = await this.controller.downloadFile(
      params.name,
      nmIdentificacaoParserFile
    )
    const link = document.createElement('a')

    const src = URL.createObjectURL(file)
    if (this.extension === this.extensions.pdf) {
      this.source = pdf.createLoadingTask(src)
      if (this.source.promise.then) {
        this.source.promise.then((p) => {
          this.numPages = p.numPages
        })
      } else {
        this.numPages = 1
      }
    } else {
      this.source = src
    }
    this.$refs.docModal.show()
  }

  clearServiceOrder () {
    this.$refs.dynamicForm.resetForm()
    this.renderModal = false
  }

  async actionButtonDetail (row) {
    this.detailMode = true
    const formData = await this.controller.pesquisarServiceOrderByIdDetalhar(
      row.id
    )
    const { registros } = await this.controller.pesquisarFiles({
      supportCall: row.id
    })
    const { dadosForm } = formData[0]
    const form = await this.controller.loadFormDetalhar()
    this.serviceOrderModalForm = form
    this.serviceOrderModalForm[0].dadosForm = dadosForm
    this.serviceOrderModalForm[0].dadosForm.id = row.id
    this.serviceOrderModalForm[0].dadosForm.supportCallChangeFiles = registros
    const currentDate = this.convertDate(new Date(dadosForm.callDate))
    this.serviceOrderModalForm[0].dadosForm.date = currentDate
    this.renderModal = true
  }

  async saveServiceOrder () {
    if (this.$refs.dynamicForm.isValidForm()) {
      if (
        this.serviceOrderModalForm.dadosForm.applicantType === 50050001 &&
        this.serviceOrderModalForm.dadosForm.email == null
      ) {
        messageBox.warn(this.$gettext('ANONYMOUS_EMAIL_MISSING_MESSAGE'))
      } else if (
        this.serviceOrderModalForm.dadosForm.applicantType === 50050002 &&
        this.serviceOrderModalForm.dadosForm.applicant == null
      ) {
        messageBox.warn(this.$gettext('IDENTIFIED_PERSON_MISSING_MESSAGE'))
      } else {
        await this.controller.gravarServiceOrder(
          this.serviceOrderModalForm.dadosForm
        )
        const { registros } = await this.controller.pesquisarServiceOrder({
          consumerUnit: this.$route.params.consumerUnit,
          serviceRequest: this.$route.params.protocol,
          supportCallClassificationType: this.tab
        })
        this.serviceOrderFormData = registros
        this.clearServiceOrder()
      }
    }
  }

  async searchServiceOrder () {
    const { registros } = await this.controller.pesquisarServiceOrder({
      ...this.serviceOrderModalForm.dadosForm,
      supportCallClassificationType: this.tab
    })
    this.serviceOrderFormData = registros
    this.clearServiceOrder()
    this.searchMode = false
  }

  async editServiceOrder () {
    if (this.$refs.dynamicForm.isValidForm()) {
      await this.controller.alterarServiceOrder(
        this.serviceOrderModalForm.dadosForm
      )
      const { registros } = await this.controller.pesquisarServiceOrder({
        consumerUnit: this.$route.params.consumerUnit,
        serviceRequest: this.$route.params.protocol,
        supportCallClassificationType: this.tab
      })
      this.serviceOrderFormData = registros
      this.clearServiceOrder()
      this.editMode = false
    }
  }

  async mounted () {
    this.serviceOrderForm =
      await this.controller.pesquisarServiceOrderDataTable(
        this.$route.params.consumerUnit,
        this.$route.params.protocol
      )
    const { registros } = await this.controller.pesquisarServiceOrder({
      consumerUnit: this.$route.params.consumerUnit,
      serviceRequest: this.$route.params.protocol,
      supportCallClassificationType: this.tab
    })
    this.serviceOrderFormData = registros
    this.key = this.key + 1
  }

  async loadFields () {
    const params = this.$route.params
    const consumerUnit = params.consumerUnit
    const consumerUnitData = await this.controller.getConsumerUnit(
      consumerUnit
    )
    const serviceRequest = params.protocol
    const date = new Date()
    const currentDate = this.convertDate(date)
    this.serviceOrderModalForm.dadosForm.consumerUnit = consumerUnit
    this.serviceOrderModalForm.dadosForm.serviceRequest = serviceRequest
    this.serviceOrderModalForm.dadosForm.consumerUnitCode = consumerUnit
      .toString()
      .padStart(6, '0')
    this.serviceOrderModalForm.dadosForm.consumerUnitConcessionContractCity =
      consumerUnitData.city
    this.serviceOrderModalForm.dadosForm.consumerUnitRoute =
      consumerUnitData.route
    this.serviceOrderModalForm.dadosForm.date = currentDate
  }

  convertDate (date) {
    const currentDate = `${('0' + date.getDate()).slice(-2)}/${(
      '0' +
      (date.getMonth() + 1)
    ).slice(-2)}/${date.getFullYear()} ${('0' + date.getHours()).slice(-2)}:${(
      '0' + date.getMinutes()
    ).slice(-2)}:${('0' + date.getSeconds()).slice(-2)}`
    return currentDate
  }

  closeModal () {
    this.renderModal = false
    this.editMode = false
    this.detailMode = false
    this.searchMode = false
  }

  closeModalFile () {
    this.renderModalFile = false
  }

  async selections ({ applicant }) {
    const person = await this.controller.getPerson(applicant.idField)
    this.serviceOrderModalForm.dadosForm.applicantEmail = person.email
    this.serviceOrderModalForm.dadosForm.phone = person.phone
    this.serviceOrderModalForm.dadosForm.applicantDocument = person.document
  }

  async actionButtonChange (row) {
    this.editMode = true
    const formData = await this.controller.pesquisarServiceOrderById(row.id)
    const { dadosForm } = formData[0]
    const form = await this.controller.loadFormAlterar({ id: row.id })
    const { registros } = await this.controller.pesquisarFiles({
      supportCall: row.id
    })
    this.serviceOrderModalForm = form[0]
    this.serviceOrderModalForm.dadosForm = dadosForm
    this.serviceOrderModalForm.dadosForm.id = row.id
    const currentDate = this.convertDate(new Date(dadosForm.callDate))
    this.serviceOrderModalForm.dadosForm.date = currentDate
    this.serviceOrderModalForm.dadosForm.supportCallChangeFiles = JSON.parse(
      JSON.stringify(registros)
    )
    this.serviceOrderModalForm.dadosForm.supportCallChangeFilesOldString =
      JSON.parse(JSON.stringify(registros))
    this.serviceOrderModalForm.dadosForm.supportCallClassificationTypeAlter =
      dadosForm.supportCallClassificationType
    this.serviceOrderModalForm.dadosForm.supportCallGroupAlter =
      dadosForm.supportCallGroup
    this.serviceOrderModalForm.dadosForm.userWasteAssignedAlter =
      dadosForm.userWasteAssigned
    this.serviceOrderModalForm.dadosForm.callStatusTypeAlter =
      dadosForm.callStatusType
    this.renderModal = true
  }

  @Watch('serviceOrderModalForm', { deep: true })
  onChangeserviceOrderModalForm (val) {
    if (!this.editMode && !this.searchMode) {
      if (val.dadosForm.applicantType === 50050001) {
        const applicant = this.serviceOrderModalForm.inputs.find(
          (input) => input.name === 'applicant'
        )
        const email = this.serviceOrderModalForm.inputs.find(
          (input) => input.name === 'email'
        )
        applicant.readonly = true
        email.readonly = false
        this.serviceOrderModalForm.dadosForm.applicant = null
      } else {
        const applicant = this.serviceOrderModalForm.inputs.find(
          (input) => input.name === 'applicant'
        )
        const email = this.serviceOrderModalForm.inputs.find(
          (input) => input.name === 'applicantEmail'
        )
        applicant.readonly = false
        email.readonly = true
        this.serviceOrderModalForm.dadosForm.email = null
      }
    }
  }

  @Watch('tab', { deep: true })
  async onChangeTab (val) {
    const { registros } = await this.controller.pesquisarServiceOrder({
      consumerUnit: this.$route.params.consumerUnit,
      serviceRequest: this.$route.params.protocol,
      supportCallClassificationType: val
    })
    this.serviceOrderFormData = registros
  }
}
export default ServiceRequestServiceOrder
</script>
<style lang="scss" scoped>
@import "tailwindcss/utilities";
.serviceOrderModalForm {
  #scroll-area {
    height: calc(73vh - 12px) !important;

    .q-scrollarea__content {
      position: relative !important;
    }
  }
}

@media only screen and (max-height: 765px) {
  .serviceOrderModalForm {
    #scroll-area {
      height: calc(78vh - 12px) !important;
    }
  }
}

.start-aligned-tabs {
  .q-tabs__content--align-center {
    padding-left: 10px;
    justify-content: start !important;
  }
}
</style>
